export default {

    //set your endpoint here
    apiEndpoint: 'https://ddsite.prismic.io/api/v2',
    siteTitle: 'Double Degree Club'

};



// WEBPACK FOOTER //
// ./src/Prismic/PrismicConfig.js